/*
 * @Description: 路由
 * @Date: 2025-03-20 15:47:26
 */
export const route = [
  {
    path: '/main/project-center-edit',
    name: 'project-center-edit',
    meta: {
      title: '编辑项目'
    },
    component: () => import('../views/project-center-edit-list.vue')
  }
];
